import styled from 'styled-components';

import Content from './Content';
import EmailSyncToggle from './EmailSyncToggle';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  justify-content: space-between;
`;

const EmailScreen = () => {
  return (
    <Wrapper>
      <Content />
      <EmailSyncToggle />
    </Wrapper>
  );
};

export default EmailScreen;
